import { AxiosInstance } from 'axios';
import React, { useEffect, useState } from 'react';
import SimpleBackdrop from 'src/components/Backdrop';
import useAxios from 'src/hooks/useAxios';
import { getAllAnnouncenments } from '../actions';
import { APP_NAME, NOTICE_TYPES } from '../constants';
import {
  IAllAnnouncementTutorial,
  IAnnouncementTutorial,
  IFetchAllPartnerRolesResponse
} from '../Interfaces';
import InboxTable from '../Table';

const Announcements = () => {
  const [selectedRole, setSelectedRole] = useState<any>([]);
  const [selectedState, setSelectedState] = useState<any>([]);
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const [pageCount, setPageCount] = React.useState<number>(1);
  const [allAnnouncenments, setAllAnnouncenments] = React.useState<
    Array<IAnnouncementTutorial>
  >([]);
  const [searchText, setSearchText] = React.useState<string>('');
  const [loading, setLoading] = useState(false);
  const API: AxiosInstance = useAxios();

  const fetchAllAnnouncements = async () => {
    try {
      setLoading(true);
      const response: IAllAnnouncementTutorial = await getAllAnnouncenments({
        API,
        appName: APP_NAME,
        pageNumber: currentPage - 1,
        selectedRole,
        state: '',
        geographyId: selectedState?.length ? selectedState[0] : '',
        noticeType: NOTICE_TYPES.announcement
      });
      if (response?.data?.elements) {
        setAllAnnouncenments(response?.data?.elements);
      }
    } catch (err) {
      //console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllAnnouncements();
  }, [currentPage]);

  const onFilter = () => {
    fetchAllAnnouncements();
  };

  return (
    <>
      <InboxTable
        data={allAnnouncenments}
        isTutorial={false}
        pageCount={pageCount}
        setPageCount={setPageCount}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSelectedRole={setSelectedRole}
        selectedRole={selectedRole}
        selectedState={selectedState}
        setSelectedState={setSelectedState}
        setSearchText={setSearchText}
        searchText={searchText}
        onFilter={onFilter}
      />
      <SimpleBackdrop open={loading} />
    </>
  );
};

export default Announcements;
